import { Injectable } from '@angular/core';
import { FacilitySignInSearch } from 'src/app/model/locations/facility-sign-in';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class MusterListTableService extends BaseTableService<FacilitySignInSearch> {
  constructor() {
    super();
  }
}
